module.exports = __webpack_public_path__ + "img/top-1.9584721d.jpg";